import React, { useState } from "react";
import { Col, Dropdown, Image, Row } from "antd";
import { useTranslation } from "react-i18next";
import trFlag from "../../assets/icons/tr-flag.png";
import enFlag from "../../assets/icons/en-flag.png";
import "./LanguageSwitcher.scss";
import { colors } from "../../utils/colors/colors";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    i18n.language ? i18n.language : "tr"
  );

  const languageOptions = [
    { value: "tr", label: "Türkçe", icon: trFlag },
    { value: "en", label: "English", icon: enFlag },
  ];

  const changeLanguage = (value: string) => {
    i18n.changeLanguage(value);
    setCurrentLanguage(value);
    setOpen(false);
  };

  const currentLang = languageOptions.find(
    (lang) => lang.value === currentLanguage
  );

  const menu = (
    <Row className="language-switcher-dropdown">
      {languageOptions.map((lang) => (
        <Col
          key={lang.value}
          style={{ color: colors.blueitNavyBlue }}
          onClick={() => changeLanguage(lang.value)}
          className={`
            language-switcher-option 
            ${currentLanguage === lang.value
              ? "language-switcher-option-active"
              : ""
            }
          `}
        >
          <Image
            src={lang.icon ? lang.icon : "tr"}
            alt={`${lang.label ? lang.label : "Türkçe"} flag`}
            preview={false}
            className="language-switcher-option-flag"
          />
          {lang.label ? lang.label : "Türkçe"}
        </Col>
      ))}
    </Row>
  );

  return (
    <Dropdown open={open}
      onOpenChange={setOpen}
      overlay={menu} placement="bottomRight" trigger={["click"]}>
      <Row className="language-switcher-trigger">
        <Image
          src={currentLang?.icon ? currentLang?.icon : trFlag}
          alt={`${currentLang?.label ? currentLang?.label : "tr"} flag`}
          className="language-switcher-flag"
          preview={false}
        />
      </Row>
    </Dropdown>
  );
};

export default LanguageSwitcher;
